import script from "./PriceRange.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceRange.vue?vue&type=script&lang=ts&setup=true"

import "./PriceRange.vue?vue&type=style&index=0&id=127539ab&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-127539ab"]])

export default __exports__